<template>
    <div class="text-wrapper" v-if="text" ref="foldTextWrapper">
        <div :class="textContainerClass" :style="textContainerStyle">
            <span class="btn" v-if="isShowExpand" @click="handleExpand">展开</span>
            <span class="unfoldBtn" v-if="isShowFold" @click="() => (checked = false)">收起</span>
            <a ref="foldText" v-if="contentUrl" :href="contentUrl">
                {{ text }}
            </a>
            <span class="fold-text" ref="foldText" v-else>
                {{ text }}
            </span>
        </div>
    </div>
</template>

<script>

import { sendAction } from '@/utils/spm_utils'
import { acodeConfig } from '@/config/spmConfig'
import Util from '@/_utils/util';

export default {
    props: {
        text: {
            type: String,
            default: ''
        },
        lineClamp: {
            type: Number,
            default: 3
        },
        contentUrl: {
            type: String,
            default: "",
        },
        articleId:{
            type: String,
            default: "",
        }
    },
    data() {
        return {
            checked: false,
            showExpand: false,
            canCollapse: false, // 是否可以折叠
        }
    },
    computed: {
        textContainerStyle() {
            let result = {}
            const lineHeight = 24
            if (!this.checked) {
                result.maxHeight = `${this.lineClamp * lineHeight}px`
            }
            return result
        },
        textContainerClass(){
            return {
                'text': true,
                'unfold': this.checked
            }
        },
        isShowExpand(){
            return !this.checked && this.showExpand
        },
        isShowFold(){
            return this.checked
        }
    },
    mounted() {
        this.$nextTick(() => {
            this.showExpand = this.text && (this.$refs.foldText?.offsetHeight > this.$refs.foldTextWrapper?.offsetHeight)
        })
        const resizeCallback = Util.throttle(()=>{
            this.showExpand = this.$refs.foldText.offsetHeight > this.$refs.foldTextWrapper.offsetHeight
        }, 200)
        window.addEventListener('resize', resizeCallback)
    },
    methods: {
        handleExpand() {
            this.checked = true
            sendAction({
                acode: acodeConfig.expandComment,
                clkParam: `id:${this.articleId};url:${window.location?.href}`
            })
        }
    }
};
</script>

<style lang="less" scoped>
.text-wrapper {
    width: 100%;
    display: flex;
    overflow: hidden;

    .text {
        font-family: PingFangSC, PingFang SC;
        font-weight: 400;
        font-size: 16px;
        color: #FFFFFF;
        overflow: hidden;
        text-overflow: ellipsis;
        position: relative;
    }

    .text.unfold {
        max-height: 100em;
    }

    .btn::before {
        content: '...';
        position: absolute;
        left: 3PX;
        color: #fff;
    }

    .btn,
    .unfoldBtn {
        position: absolute;
        right: 0;
        float: right;
        clear: both;
        font-size: 15PX;
        /*px*/
        line-height: 24PX;
        /*px*/
        border-radius: 4PX;
        color: #FFFFFF;
        cursor: pointer;
        display: block;
        font-weight: 600;
        font-family: PingFangSC, PingFang SC;
        background: linear-gradient(90deg, hsla(231, 9%, 15%, 0), #23242F 10%);
    }

    .btn {
        padding-left: 20PX;
        bottom: 0PX;
    }

    .unfoldBtn {
        bottom: 0;
        z-index: 2;
    }

    .fold-text {
        overflow: hidden;
        line-height: 24PX !important;
    }
}
</style>